document.addEventListener('DOMContentLoaded', function () {
  const root = document.querySelector('.slider-textvid-swiper');
  if (!root) return;

  // Wait for Swiper to be fully loaded
  function initWhenSwiperReady() {
    if (typeof Swiper !== 'undefined') {
      initSlider();
    } else {
      setTimeout(initWhenSwiperReady, 100);
    }
  }

  function initSlider() {
    const loopEnabled = root.dataset.loop === 'true';
    const autoplayDelay = Number(root.dataset.autoplay);
    
    new Swiper(root, {
      loop: loopEnabled,
      autoplay: loopEnabled && autoplayDelay > 0 ? { delay: autoplayDelay } : false,
      pagination: {
        el: '.slider-textvid-swiper-pagination',
        clickable: true,
      },
      slidesPerView: 1,
      spaceBetween: 20,
      wrapperClass: 'slider-textvid-swiper-wrapper',
      slideClass: 'slider-textvid-swiper-slide',
    });
  }

  initWhenSwiperReady();
});
